module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.request.loading) ? [_c('v-progress-linear', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "indeterminate": "",
      "height": "2"
    }
  })] : [(_vm.request.status === 400) ? _c('server-errors', {
    attrs: {
      "request": _vm.request
    }
  }) : (_vm.request.status >= 300 && _vm.message) ? _c('v-alert', {
    staticClass: "pa-2 mt-0",
    attrs: {
      "dense": "",
      "dismissible": "",
      "type": _vm.messageType,
      "value": true
    }
  }, [_vm._v("\n      " + _vm._s(_vm.message) + "\n      "), _c('v-btn', {
    staticClass: "ml-3",
    attrs: {
      "outline": "",
      "small": "",
      "color": "white"
    },
    on: {
      "click": _vm.reload
    }
  }, [_vm._v("Refresh app")])], 1) : _vm._e()], _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": _vm.messageType
    },
    model: {
      value: (_vm.showSnacker),
      callback: function($$v) {
        _vm.showSnacker = $$v
      },
      expression: "showSnacker"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.message) + "\n    "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "outline": ""
    },
    on: {
      "click": function($event) {
        _vm.showSnacker = false
      }
    }
  }, [_vm._v("close")])], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9eb24cb6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/RequestStatus.vue
// module id = 1502
// module chunks = 9